<template>
  <modal
    class="POSModal"
    name="CompanyPOSettlement"
    transition="pop-out"
    :width="modalWidth"
    :height="400"
  >
    <div>
      <div class="full__row_section mb-5">
        <div class="w-75 mx-auto pos_modal ml-3">
          <h3 class="text-center py-4">POS Settlement</h3>

          <div>
            <label> Account Bank: {{ settlementAcct.bank }}</label>

            <div>
              <label> Account Name: {{ settlementAcct.accountName }}</label>
            </div>

            <div>
              <label>Account Number: {{ settlementAcct.accountNumber }}</label>
            </div>
          </div>

          <div class="mx-auto mb-3">
            <label> {{ $t("text.products.enterAmount") }}: </label>

            <input
              class=""
              type="number"
              :placeholder="$t('text.form.amount')"
              v-model="amount"
            />
          </div>

          <!-- settlement button -->
          <div class="text-center">
            <button
              class="w-75 save__btn record_expense_btn btn_primary_color w-50"
              @click="settlePOS"
              :disabled="isButtonDisabled"
            >
              {{ $t("text.products.settle") }}
              <span
                ><img
                  src="/img/git_loader.8264c9b1.gif"
                  width="25px"
                  class="loader ml-2"
                  style="display: none"
              /></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 656;

export default {
  name: "CompanyPOSettlement",
  props: ["company", "settlementAcct"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      amount: null,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    settlePOS() {
      if (!this.amount) {
        this.$toast.open({
          message: this.$t("text.errors.enterAmount"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let data = {
        amount: Number(this.amount),
        companyId: this.company.id,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      let _this = this;
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Settlement/CompanyPosSettlement`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.closeModal();
          this.$toast.open({
            message: this.$t("text.requests.settementSuccessful"),
            type: "success",
            duration: 3000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;

          this.showLoader = false;
          this.$eventHub.$emit("refreshTransaction");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          $(".loader").hide();
        });
    },

    closeModal() {
      this.$modal.hide("POSModal");
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
